<div class="card margin-b ">

    <div class="card-body border-r ">
        <div class="main-box">
            <div class="image-wrapper">
                <img src="assets/church_image.jpg">
            </div>
            <div class="text-area">
                <div>
                    <h5 class="card-title">Abundant Living Faith Center</h5>
                </div>
                <div *ngIf="showDate === true" class="time-text">
                    <span><i class="far fa-clock"></i></span>
                    <span>
                        <p >July at 7:13 AM</p>
                    </span>

                </div>

            </div>

        </div>


        <p class="card-text">It is a long established fact that a reader will be distracted by the readable content of a
            page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal
            distribution
            of letters, as opposed to using 'Content here, content here', making it look like readable English.</p>

    </div>
</div>